import { Dialog, DialogActionsProps, DialogProps, styled } from '@mui/material'
import clsx from 'clsx'
import { Button } from 'components/Button/Button'
import React from 'react'

import { Loading } from './Loading'

import confirmStyle from 'components/ConfirmDialog/ConfirmDialog.module.css'

const dialogClasses = {
  title: 'confirmation-dialogue-info-value',
  actionBtn: 'confirmation-dialogue-action-button',
}
const StyledDialog = styled((props: DialogProps) => <Dialog {...props} />)(() => ({
  [`& .${dialogClasses.title}`]: {
    flex: '1 1 auto',
  },
  [`& .${dialogClasses.actionBtn}`]: {
    minWidth: 80,
  },
}))

export interface ConfirmationDialogProps extends DialogProps {
  title?: string
  confirmText?: string
  cancelText?: string
  // disable the dialog actions and shows a loading indicator
  submitting?: boolean
  classes?: DialogActionsProps['classes'] & { button: string }
  toolbar?: React.ReactNode
  onSubmit?: React.FormEventHandler
  isSmall?: boolean
  danger?: boolean
  disableConfirm?: boolean
}

export function ConfirmationDialogAllSingle({
  title = 'Confirm',
  confirmText = 'OK',
  cancelText = 'Cancel',
  submitting = false,
  classes,
  onSubmit,
  toolbar,
  onClose,
  children,
  isSmall = false,
  danger = false,
  disableConfirm = false,
  ...otherProps
}: ConfirmationDialogProps): JSX.Element {
  return (
    <StyledDialog
      onClose={onClose}
      {...otherProps}
      PaperProps={{
        sx: {
          maxWidth: '500px',
          width: '100%',
          height: 'auto',
          borderRadius: '2px',
          padding: '0px 35px 32px 35px',
        },
      }}
    >
      <form
        onSubmit={ev => {
          ev.preventDefault()
          onSubmit && onSubmit(ev)
        }}
        aria-label={title}
      >
        <div className={confirmStyle.titleBlock}>
          <div className={confirmStyle.title}>{title}</div>
          {toolbar}
        </div>
        <div>{children}</div>
        <div className={confirmStyle.footer} style={children ? { paddingTop: 0 } : {}}>
          <Button.Outlined
            onClick={ev => onClose && onClose(ev, 'escapeKeyDown')}
            disabled={submitting}
            className={confirmStyle.btn}
            size="medium"
          >
            {cancelText}
          </Button.Outlined>
          <Button.Standart
            type="submit"
            disabled={submitting || disableConfirm}
            className={danger ? clsx(confirmStyle.btn, confirmStyle.btnRed) : confirmStyle.btn}
            size="medium"
          >
            <Loading hideChildren loading={submitting} size="1.5em" color="inherit">
              {confirmText}
            </Loading>
          </Button.Standart>
        </div>
      </form>
    </StyledDialog>
  )
}
